<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route  = useRoute()
const router = useRouter()
const tabs = [
  { id: 'airdrop',  path: '/airdrop',  labelKey: 'tabs.airdrop'  },
  { id: 'roadmap',  path: '/roadmap',  labelKey: 'tabs.roadmap'  },
  { id: 'rules',    path: '/rules',    labelKey: 'tabs.rules'    },
  { id: 'profile',  path: '/profile',  labelKey: 'tabs.profile'  },
]
const activeTab = computed(() => route.name)
const showComingSoon = ref(false)

function navigateTo(tab) {
  if (tab.id === 'rules') {
    showComingSoon.value = true
    return
  }
  if (route.name !== tab.id) {
    router.push(tab.path)
  }
}
</script>

<template>
  <nav class="pixel-nav">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      class="pixel-nav-item"
      :class="{ active: activeTab === tab.id }"
      @click="navigateTo(tab)"
    >
      <span class="pixel-nav-label">{{ t(tab.labelKey) }}</span>
      <span class="pixel-nav-triangle" :class="{ visible: activeTab === tab.id }" />
    </button>
  </nav>

  <Transition name="fade">
    <div v-if="showComingSoon" class="modal-overlay" @click.self="showComingSoon = false">
      <div class="pixel-modal">
        <div class="pixel-modal-content">
          <div class="pixel-icon">⏳</div>
          <h3 class="pixel-title">{{ t('comingSoon') }}</h3>
          <button class="pixel-close-btn" @click="showComingSoon = false">
            {{ t('draw.action.close') || 'CLOSE' }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.pixel-nav { display: flex; background: var(--color-bg-base); border-top: 2px solid var(--color-primary-border); position: relative; z-index: 10; }
.pixel-nav-item { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; height: 3rem; background: none; border: none; color: var(--color-text-tertiary); cursor: pointer; transition: color 0.15s; overflow: hidden; }
.pixel-nav-item.active { color: var(--color-primary); }
.pixel-nav-triangle { flex-shrink: 0; width: 0; height: 0; border-style: solid; border-width: 0 3px 4px 3px; border-color: transparent transparent transparent transparent; }
.pixel-nav-triangle.visible { border-color: transparent transparent var(--color-primary) transparent; }
.pixel-nav-label { font-family: var(--font-pixel); font-size: 0.35rem; letter-spacing: 0.02em; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; text-align: center; }

/* Modal Styles */
.modal-overlay { position: fixed; inset: 0; z-index: var(--z-modal); display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.85); backdrop-filter: blur(4px); padding: var(--space-4); }
.pixel-modal { width: 100%; max-width: 300px; background: var(--color-bg-elevated); border: 2px solid var(--color-primary-border); box-shadow: 0 0 20px rgba(245,158,11,0.15); position: relative; animation: modal-pop 0.3s var(--ease-spring); }
.pixel-modal-content { padding: var(--space-6) var(--space-4); display: flex; flex-direction: column; align-items: center; gap: var(--space-4); text-align: center; }
.pixel-icon { font-size: 1.5rem; line-height: 1; }
.pixel-title { font-family: var(--font-pixel); font-size: 0.5rem; color: var(--color-text-gold); line-height: 1.4; text-transform: uppercase; }
.pixel-close-btn { margin-top: var(--space-2); padding: var(--space-2) var(--space-6); font-family: var(--font-pixel); font-size: 0.4rem; background: var(--color-bg-surface); border: 1px solid var(--color-border-muted); color: var(--color-text-secondary); cursor: pointer; transition: all var(--duration-fast); }
.pixel-close-btn:active { transform: translate(1px, 1px); border-color: var(--color-primary); color: var(--color-primary); }

@keyframes modal-pop { 0% { transform: scale(0.9); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
